// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"16e97c82","496":"23daa75d","677":"36a82191"}[chunkId] + ".chunk.js";
};